import { Component } from '@angular/core';
import { UilabMatRadioModule } from '@uilab/ng-mat-components';
import { CodeExampleComponent } from 'src/app/shared/components/code-example/code-example.component';
import { CodeExampleHeaderComponent } from 'src/app/shared/components/code-example/code-example-header.component';
import { COMPONENT_EXAMPLES_CONSTANTS } from '../component-examples.constants';

interface RadioExample {
    readonly variant: 'default';
    readonly label: string;
    readonly description: string;
    readonly htmlSnippet: string;
    readonly options: readonly {
        readonly label: string;
        readonly value: string;
    }[];
    readonly selectedValue: string;
}

@Component({
    selector: 'avd-radio-examples',
    templateUrl: './radio-examples.component.html',
    styleUrls: ['./radio-examples.component.scss'],
    imports: [
        CodeExampleHeaderComponent,
        CodeExampleComponent,
        UilabMatRadioModule,
    ],
})
export class RadioExamplesComponent {
    readonly packageName = COMPONENT_EXAMPLES_CONSTANTS.PACKAGE_NAME;
    readonly getStartedLink = COMPONENT_EXAMPLES_CONSTANTS.GET_STARTED_LINK;
    readonly storybookLink =
        'https://calm-mushroom-0d2458d1e.2.azurestaticapps.net/?path=/docs/components-form-controls-radio-button--docs';
    readonly repoLink =
        'https://dev.azure.com/AVEVA-VSTS/UX/_git/uilab-base?version=GBfeat/angular-material-components&path=/projects/components/src/lib/radio';

    readonly examples: readonly RadioExample[] = [
        {
            variant: 'default',
            label: 'Default Radio Group',
            description:
                'Use radio buttons when users must choose exactly one option from a short list.',
            htmlSnippet:
                '<uilab-mat-radio-group value="option1" aria-label="Options">\n    <uilab-mat-radio-button value="option1">Option 1</uilab-mat-radio-button>\n    <uilab-mat-radio-button value="option2">Option 2</uilab-mat-radio-button>\n</uilab-mat-radio-group>',
            options: [
                { label: 'Option 1', value: 'option1' },
                { label: 'Option 2', value: 'option2' },
            ],
            selectedValue: 'option1',
        },
    ];
}
